<template>
  <v-card>
    <v-tabs v-model="active">
      <v-tab v-for="n in categories" :key="n[0]" ripple>{{ n[1] }}</v-tab>
    </v-tabs>
    <div v-if="active === 0">
      <FormLine
        v-model="companies"
        :item="{ name: 'from', label: 'Depuis', as: 'date' }"
        :edit-mode="true"
      />
      <FormLine
        v-model="companies"
        :item="{ name: 'to', label: `Jusqu'à`, as: 'date' }"
        :edit-mode="true"
      />
      <v-btn @click="downloadCompanies">
        <v-icon left class="hidden-sm-and-down">cloud_download</v-icon>
        Télécharger
      </v-btn>
    </div>
    <v-list>
      <v-list-tile v-for="r in reports" :key="r._id">
        <v-list-tile-content>{{ r.name }}</v-list-tile-content>
        <v-list-tile-action>
          <a @click="download(r)" download>
            <v-icon>get_app</v-icon>
          </a>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
import FormLine from "@/components/commons/FormLine";
import moment from "moment";
import { fetchHil } from "../utils";
import { mapActions, mapState } from "vuex";
import { downloadFile } from "../../../webapp-commons/functions";

export default {
  components: { FormLine },
  data() {
    return {
      active: 0,
      categories: [
        ["companies", "Entreprises"],
        ["factures-recues", "Fact. Reçues"],
        ["factures-emises", "Fact. Emises"],
        ["mandats", "Mandats"],
        ["commercial", "Commercial"],
        ["b2c", "B2C"]
      ],
      companies: {
        from: moment()
          .subtract(1, "year")
          .toISOString(),
        to: new Date().toISOString()
      }
    };
  },
  async mounted() {
    await this.fetchReports();
  },
  methods: {
    ...mapActions("admin", ["fetchReports"]),
    href(item) {
      return (
        process.env.VUE_APP_DOMAIN +
        item.href +
        "?token=" +
        localStorage.getItem("hil_token")
      );
    },
    async download({ _id }) {
      const data = await fetchHil(`/cache/file/${_id}`);
      await downloadFile(data);
    },
    async downloadCompanies() {
      const qs = new URLSearchParams({
        startDate: moment(this.companies.from)
          .startOf("day")
          .toISOString(),
        endDate: moment(this.companies.to)
          .endOf("day")
          .toISOString(),
        version: 4
      });
      const data = await fetchHil(`/reports/companies?${qs}`);
      await downloadFile(data);
    }
  },
  computed: {
    ...mapState("admin", {
      allReports: state => state.reports
    }),
    reports() {
      const suff = this.categories[this.active][0] + ".csv";
      return this.allReports.filter(r => r.name.endsWith(suff));
    }
  }
};
</script>
